export const TRANSLATIONS_JP_ONBOARDING = {
  "homePublic.hero.eyebrow": "ライブビュー",
  "homePublic.hero.title": "接続前でも確認できるエンタープライズ水準のワークスペース",
  "homePublic.hero.subtitle":
    "匿名化された指標で満たされたモック環境を体験し、Innovadoc IA が本番導入前にチームをどう整合させるかを確認しましょう。",
  "homePublic.hero.ctaPrimary": "アカウントを作成",
  "homePublic.hero.ctaSecondary": "既存ワークスペースへ",
  "homePublic.hero.metrics.documents": "インデックス済みドキュメント",
  "homePublic.hero.metrics.latency": "中央値レスポンス",
  "homePublic.hero.metrics.compliance": "ナレッジカバレッジ",
  "homePublic.mock.eyebrow": "モックテレメトリ",
  "homePublic.mock.title": "安全なデータで生成されたシグナル",
  "homePublic.mock.subtitle":
    "実トラフィックを想定したプラットフォームの感触がわかるよう自動更新されています。",
  "homePublic.mock.cards.documents.label": "今週のドキュメント",
  "homePublic.mock.cards.documents.detail": "直近7日で同期されたユニークアップロード",
  "homePublic.mock.cards.repositories.label": "接続済みソース",
  "homePublic.mock.cards.repositories.detail": "Drive / SharePoint / S3 / Gmail など",
  "homePublic.mock.cards.users.label": "アクティブシート",
  "homePublic.mock.cards.users.detail": "チャットやオートメーションを利用中のメンバー",
  "homePublic.mock.cards.alerts.label": "注意アラート",
  "homePublic.mock.cards.alerts.detail": "管理者に残っている是正項目",
  "homePublic.features.eyebrow": "得られるもの",
  "homePublic.features.title": "初日からエンタープライズ対応",
  "homePublic.features.subtitle": "本番データに触れずに体験を検証するためのすべてを提供します。",
  "homePublic.features.ingestion.title": "シームレスなインジェスト",
  "homePublic.features.ingestion.desc": "フォルダを投入し、メールを転送し、数分でリポジトリを接続できます。",
  "homePublic.features.security.title": "セキュリティ最優先",
  "homePublic.features.security.desc": "SOC 2 準拠のコントロール、粒度の細かい権限、ワークスペース分離。",
  "homePublic.features.operations.title": "オペレーション対応",
  "homePublic.features.operations.desc": "ライブダッシュボード、ヘルスアラート、ヒューマン・イン・ザ・ループのタスクキュー。",
  "homePublic.plan.eyebrow": "プラン概要",
  "homePublic.plan.title": "実効的なセーフガード付きスタータープラン",
  "homePublic.plan.subtitle": "社内ステークホルダーと RAG 体験を検証するイノベーションリーダー向け。",
  "homePublic.plan.points.speed.title": "高速なパイロット",
  "homePublic.plan.points.speed.desc": "専用のベクターストアとすぐ使えるチャットフローを提供。",
  "homePublic.plan.points.context.title": "信頼できるコンテキスト",
  "homePublic.plan.points.context.desc": "PII を自動検出し、リポジトリを分類し、各チャンクのトレーサビリティを保持。",
  "homePublic.plan.points.support.title": "伴走型ロールアウト",
  "homePublic.plan.points.support.desc": "カスタマーサクセスチームと非同期オフィスアワーで進行を支援。",
  "homePublic.plan.card.title": "含まれる内容",
  "homePublic.plan.card.subtitle": "10ユーザー・2ワークスペース・5万プロンプトクレジット・プレミアムテレメトリ。",
  "homePublic.plan.card.ctaPrimary": "無料パイロットを開始",
  "homePublic.plan.card.ctaSecondary": "エンタープライズプランを見る",
  "homePublic.testimonial.quote": "このモック環境のおかげで、コンプライアンスチームは1週間で展開を承認できました。",
  "homePublic.testimonial.author": "Lucía Hernández",
  "homePublic.testimonial.role": "AIトランスフォーメーション責任者（Vectoris）",
  "homePublic.cta.title": "ドキュメントが動き出す瞬間を見てみませんか？",
  "homePublic.cta.subtitle": "今日からモックデータで Innovadoc IA を起動し、法務の許可が出次第リポジトリを接続しましょう。",
  "homePublic.cta.primary": "ワークスペースを起動",
  "homePublic.cta.secondary": "専門家に相談",
  "wizard.welcome_title": "ウィザードへようこそ！",
  "wizard.welcome_image_alt": "ウェルカムイラスト",
  "wizard.welcome_description":
    "プロフィールと設定を行い、システムの利用を開始しましょう。",
  "wizard.profile_title": "プロフィール情報",
  "wizard.profile_description": "あなたと組織について教えてください。",
  "wizard.preferences_title": "設定",
  "wizard.preferences_description":
    "テーマ、言語、その他のオプションを選択して体験をカスタマイズしましょう。",
  "wizard.complete_title": "完了！",
  "wizard.complete_description": "プロフィールが正常に設定されました。",
  "wizard.feature_chat_title": "スマートチャット",
  "wizard.feature_chat_desc":
    "質問をして、ドキュメントに基づいた正確な回答を得ましょう。",
  "wizard.feature_docs_title": "ドキュメント管理",
  "wizard.feature_docs_desc":
    "ドキュメントを簡単にアップロード、整理、検索できます。",
  "wizard.feature_insights_title": "分析とインサイト",
  "wizard.feature_insights_desc": "データから関連する分析と統計を取得します。",
  "wizard.first_name": "名",
  "wizard.first_name_required": "名は必須です。",
  "wizard.lastname": "姓",
  "wizard.lastname_required": "姓は必須です。",
  "wizard.name_required": "名前は必須です。",
  "wizard.country": "国",
  "wizard.country_required": "国は必須です。",
  "wizard.job_title": "役職",
  "wizard.job_required": "役職は必須です。",
  "wizard.company": "会社",
  "wizard.company_required": "会社は必須です。",
  "wizard.timezone": "タイムゾーン",
  "wizard.timezone_select": "タイムゾーンを選択してください",
  "wizard.timezone_required": "タイムゾーンは必須です。",
  "wizard.timezone_search": "都市またはゾーンを検索...",
  "wizard.timezone_no_results": "結果なし",
  "wizard.org_type": "組織タイプ",
  "wizard.org_enterprise": "企業",
  "wizard.org_education": "教育",
  "wizard.org_government": "政府",
  "wizard.org_nonprofit": "非営利",
  "wizard.org_other": "その他",
  "wizard.org_size": "組織規模",
  "wizard.size_small": "小規模 (1-50)",
  "wizard.size_medium": "中規模 (51-250)",
  "wizard.size_large": "大規模 (251-1000)",
  "wizard.size_enterprise": "大企業 (1000+)",
  "wizard.theme_preference": "テーマの好み",
  "wizard.language_preference": "言語の好み",
  "wizard.yes": "はい",
  "wizard.no": "いいえ",
  "wizard.other_preferences": "その他の好み",
  "wizard.enable_notifications": "通知を有効にする",
  "wizard.allow_data_collection": "匿名データ収集を許可する",
  "wizard.data_collection_info":
    "あなたのデータはシステム改善に役立ちます。個人情報は収集されません。",
  "wizard.summary_title": "設定の概要",
  "wizard.previous": "前へ",
  "wizard.next": "次へ",
  "wizard.complete": "完了",
  "wizard.save_error":
    "設定の保存中にエラーが発生しました。再試行してください。",
  "wizard.copy_support_reference": "コードをコピー",
  "wizard.support_reference_copied": "コピー済み",
  "wizard.second_name": "苗字",
  "wizard.second_name_required": "苗字は必須です。",
  filtered_results: "フィルター結果",
  "invite.validating": "招待を検証しています...",
  "invite.invalid_or_expired": "無効または期限切れの招待",
  "invite.invalid_or_expired_desc": "招待リンクは有効ではありません。管理者に新しい招待を依頼してください。",
  "invite.missing_params": "招待情報が不足しています",
  "invite.missing_params_desc": "招待リンクに続行に必要な情報が含まれていません。",
  "invite.not_found": "招待が見つかりません",
  "invite.not_found_desc": "このメールアドレスの有効な招待が見つかりませんでした。",
  "invite.server_error": "招待を検証できませんでした",
  "invite.server_error_desc": "招待の検証中にエラーが発生しました。後でもう一度お試しください。",
  "invite.bad_request": "送信された情報が有効ではありません。",
  "invite.back_to_login": "ログインに戻る",
  "invite.email": "招待メール",
  "invite.company": "会社",
  "invite.role": "ロール",
  "invite.company_from_invite": "会社は招待によって指定されています。",
  "invite.password_step": "パスワードを作成",
  "invite.password_step_desc": "アクセスを完了するため、安全なパスワードを設定してください。",
  "invite.password": "パスワード",
  "invite.password_placeholder": "パスワードを入力",
  "invite.password_required": "パスワードは必須です。",
  "invite.password_min_length": "パスワードは8文字以上で入力してください。",
  "invite.password_hint": "8文字以上を使用してください。",
  "invite.confirm_password": "パスワードの確認",
  "invite.confirm_password_placeholder": "パスワードを再入力",
  "invite.passwords_not_match": "パスワードが一致しません。",
};
